module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-03.0fcf6e1c.svg";